// extracted by mini-css-extract-plugin
module.exports = {"ticket-task-list":"_3gMqIMOgyLcnY8q2XVHUAl"};